import React, { Component, Fragment } from "react";
import { withTranslation } from "react-i18next";
import CourseGroupsView from "../../courseGroup/views/CourseGroupsView";
import i18n from "../../../i18n";
import {
  FormUtility,
  withAuthentication,
  withCoursePortalApi,
  withCourseContactApi,
  withCourseGroupsApi,
  withProfileApi,
  withCourseStatisticsApi,
} from "cw-styleguide-react";
import { route } from "../../../routes";
import { LANGUAGE_CY, LANGUAGE_EN } from "../../../constants";
import validate from "validate.js";
import withAuditApi from "../../../apis/withAuditApi";

class CourseGroupsController extends Component {
  /**
   * constructor.
   * @param props
   */
  constructor(props) {
    super(props);

    // Set the initial state..
    this.state = {
      values: this.getInitialValues(),
      inputLanguage: LANGUAGE_EN,
      submitting: false,
      formErrors: [],
      messages: new Set(),
      redirect: null,
      manualContactName: false,
      modals: {
        delete: false,
        archive: false,
      },
      reloadKey: Math.random(),
      loaded: false,
      query: "",
    };

    this.constraints = {
      subContractedProviderId: {
        presence: {
          allowEmpty: false,
          message: this.props.t(
            "local:view.courseGroups.create.field.subContractedProvider.required"
          ),
        },
      },
    };

    this.handleSetInputLanguage = this.handleSetInputLanguage.bind(this);
    this.handleErrorClick = this.handleErrorClick.bind(this);
    this.loadAudit = this.loadAudit.bind(this);
    this.loadCourseGroup = this.loadCourseGroup.bind(this);
    this.saveCourseGroup = this.saveCourseGroup.bind(this);
    this.deleteCourseGroup = this.deleteCourseGroup.bind(this);
    this.archiveCourseGroup = this.archiveCourseGroup.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.handleBulkPermissionsCheckbox =
      this.handleBulkPermissionsCheckbox.bind(this);
    this.handleAddContact = this.handleAddContact.bind(this);
    this.handleRemoveContacts = this.handleRemoveContacts.bind(this);
    this.handleSelectContact = this.handleSelectContact.bind(this);
    this.getUsersByAtlasAccountId = this.getUsersByAtlasAccountId.bind(this);
    this.clearMessages = this.clearMessages.bind(this);
    this.clearSelected = this.clearSelected.bind(this);
    this.clearRedirect = this.clearRedirect.bind(this);
    this.clearCourseGroup = this.clearCourseGroup.bind(this);
    this.getInitialValues = this.getInitialValues.bind(this);
    this.setReloadKey = this.setReloadKey.bind(this);
    this.setQuery = this.setQuery.bind(this);
    this.clearPermissions = this.clearPermissions.bind(this);
  }

  /**
   * getInitialValues
   */
  getInitialValues() {
    return {
      id: "",
      mainProviderId: this.props.authentication.hasRole("Courses_Provider")
        ? this.props.authentication.getClaim("atlasAccountId")
        : "",
      mainProviderLabel: "",
      permissions: new Set(),
      contacts: new Set(), // Contact Ids added to the course group.
      contactsLoaded: [], // Fully loaded contact objects used for display.
      contactsSelected: new Set(), // Contacts that have been selected by their checkboxes.
      users: [],
      usersSelected: [],
      subContracted: "no",
      courseGroupName: "",
      courseGroupType: "",
      courseCount: null,
    };
  }

  /**
   * clearContact
   */
  clearCourseGroup() {
    this.setState({
      values: this.getInitialValues(),
    });
  }

  /**
   * clearPermissions
   */
  clearPermissions() {
    const values = this.state.values;
    values.permissions = new Set();
    this.setState({
      values: values,
    });
  }

  /**
   * componentDidMount.
   */
  componentDidMount() {
    if (this.props.authentication.hasRole("Courses_Provider")) {
      this.getUsersByAtlasAccountId(
        this.props.authentication.getClaim("atlasAccountId")
      );
    }

    this.retrieveContacts();
  }

  /**
   * clearSelected
   */
  clearRedirect() {
    this.setState({
      redirect: null,
    });
  }

  /**
   * clearSelected
   */
  clearSelected() {
    this.setState({
      selected: new Set(),
    });
  }

  /**
   * clearMessages
   */
  clearMessages() {
    this.setState({
      messages: new Set(),
      formErrors: {},
    });
  }

  /**
   * Set a new reload key forcing a page refresh.
   */
  setReloadKey() {
    this.setState({
      reloadKey: Math.random(),
    });
  }

  /**
   * toggleModal
   * @param id
   */
  toggleModal(ids, visiblity) {
    const modals = { ...this.state.modals };

    // loop through the ids.
    ids.forEach((id) => {
      modals[id] = visiblity;
    });

    this.setState({
      modals: modals,
    });
  }

  /**
   * Handle the bulk selection of permissions checkboxes.
   * @param event
   */
  handleSelectContact(event) {
    const values = this.state.values;
    if (values.contactsSelected.has(event.target.value)) {
      values.contactsSelected.delete(event.target.value);
    } else {
      values.contactsSelected.add(event.target.value);
    }
    this.setState({
      values: values,
    });
  }

  /**
   * handleRemoveContacts
   * @param event
   */
  handleRemoveContacts(event) {
    event.preventDefault();
    const values = this.state.values;

    // Loop through all the selected contacts.
    Array.from(values.contactsSelected).forEach((element) => {
      values.contacts.delete(element);
    });
    this.setState(
      {
        values: values,
      },
      () => this.retrieveContacts()
    );
  }

  /**
   * handleAddContact
   * @param event
   */
  handleAddContact(event) {
    event.preventDefault();

    if (this.state.values.contactId) {
      if (Array.from(this.state.values.contacts).length < 1) {
        const values = this.state.values;
        values.contacts.add(this.state.values.contactId);

        values.contactId = "";
        values.contactLabel = "";
        this.setState(
          {
            values: values,
          },
          () => this.retrieveContacts()
        );
      }
    }
  }

  /**
   * retrieveContacts.
   */
  retrieveContacts() {
    if (Array.from(this.state.values.contacts).length > 0) {
      this.props.courseContactApiGetContacts(
        Array.from(this.state.values.contacts),
        { published: true },
        i18n.language,
        (response) => {
          const values = { ...this.state.values };
          values.contactsSelected = new Set();
          values.contactsLoaded = response.data;

          this.setState({
            values: values,
          });
        },
        (error) => {}
      );
    } else {
      const values = { ...this.state.values };
      values.contactsSelected = new Set();
      values.contactsLoaded = [];
      this.setState({
        values: values,
      });
    }
  }

  /**
   * Handle the bulk selection of permissions checkboxes.
   * @param event
   */
  handleBulkPermissionsCheckbox(event) {
    const values = this.state.values;
    if (values.permissions.has(event.target.value)) {
      values.permissions.delete(event.target.value);
    } else {
      values.permissions.add(event.target.value);
    }
    this.setState({
      values: values,
    });
  }

  /**
   * getUsersByAtlasAccountId.
   * @param id
   */
  getUsersByAtlasAccountId(id) {
    this.props.profileApiGetAccount(
      id,
      i18n.language,
      (response) => {
        const values = { ...this.state.values };

        values.users = Object.keys(response.data).map((id) => ({
          id: response.data[id].atlasId,
          name: response.data[id].name,
          email: response.data[id].email,
        }));

        this.setState({
          values: values,
        });
      },
      (error) => {}
    );
  }

  /**
   * loadAudit
   * @param id
   */
  loadAudit(id) {
    this.props.auditApiGetAudit(
      id,
      "courseGroup",
      i18n.language,
      (response) => {
        this.setState({
          audit: response.data,
        });
      },
      (error) => {
        this.setState({
          audit: false,
        });
      }
    );
  }

  /**
   * Load a contact for a given ID.
   * @param id
   */
  loadCourseGroup(id) {
    this.setState({
      loaded: false,
    });

    this.props.courseGroupsApiGetCourseGroups(
      [id],
      i18n.language,
      (response) => {
        let courseGroupPermissions = new Set();
        response.data[0].courseGroupPermissions &&
          response.data[0].courseGroupPermissions.forEach((element) => {
            courseGroupPermissions.add(element.atlasId);
          });

        let contacts = new Set();

        // Only add contacts if contactId and contactName is present for #14364.
        // https://dev.azure.com/ccdg/CWO%20-%20Courses/_workitems/edit/14364
        if (
          response.data[0].contact &&
          response.data[0].contact.contactId &&
          response.data[0].contact.contactName
        ) {
          contacts.add(response.data[0].contact.contactId);
        }

        this.setState(
          {
            values: {
              id: response.data[0].id,
              mainProviderId: response.data[0].mainProvider.atlasAccountId,
              mainProviderLabel:
                response.data[0].mainProvider.cw_courseprovidername,
              subContractedProviderId: response.data[0].subContractedProvider
                ? response.data[0].subContractedProvider.atlasAccountId
                : "",
              subContractedProviderLabel: response.data[0].subContractedProvider
                ? response.data[0].subContractedProvider.cw_courseprovidername
                : "",
              // Only set contactId and contactLabel if contactId and contactName is present for #14364.
              // https://dev.azure.com/ccdg/CWO%20-%20Courses/_workitems/edit/14364
              contactId:
                response.data[0].contact &&
                response.data[0].contact.contactId &&
                response.data[0].contact.contactName
                  ? response.data[0].contact.contactId
                  : "",
              contactLabel:
                response.data[0].contact &&
                response.data[0].contact.contactId &&
                response.data[0].contact.contactName
                  ? response.data[0]?.contact?.contactName?.[LANGUAGE_EN]
                  : "",
              courseGroupName: response.data[0].courseGroupName,
              courseGroupType: response.data[0].courseGroupType,
              users: [],
              permissions: courseGroupPermissions,
              contacts: contacts,
              contactsSelected: new Set(),
              contactsLoaded: [],
              subContracted: response.data[0].subContractedProvider
                ? "yes"
                : "no",
            },
            loaded: true,
          },
          () => {
            this.getUsersByAtlasAccountId(this.state.values.mainProviderId);
            this.props.courseStatisticsApiGetQ(
              this.state.values.id,
              i18n.language,
              (response) => {
                let values = this.state.values;
                values.courseCount = response.data.total;
                this.setState({
                  values: values,
                });
              },
              (error) => {}
            );
            this.retrieveContacts();
          }
        );
      },
      (error) => {
        let errors = FormUtility.processServerErrors(error, i18n);
        this.setState({
          formErrors: errors.formErrors,
          messages: errors.messages,
          loaded: false,
        });
      }
    );
  }

  /**
   * Create a contact.
   * @param status
   */
  saveCourseGroup() {
    if (this.state.values.subContracted === "yes") {
      const validated = validate(this.state.values, this.constraints, {
        fullMessages: false,
      });
      if (validated) {
        this.setState({
          formErrors: validated,
          submitting: false,
        });
        return;
      }
    }

    // Start the spinner going, will be removed on success or failure of the submit.
    this.setState({
      submitting: true,
    });

    // Build the Post JSON.
    let payload = {
      courseGroupName: this.state.values.courseGroupName,
      courseGroupType: this.state.values.courseGroupType,
      mainProvider: {
        atlasAccountId: this.state.values.mainProviderId,
      },
      courseGroupPermissions: [],
    };

    // Add permissions if we have any set.
    if (this.state.values.permissions) {
      Array.from(this.state.values.permissions).forEach((element, id) => {
        payload.courseGroupPermissions[id] = {
          atlasId: element,
        };
      });
    }

    // Add a contact if selected.
    if ([...this.state.values.contacts][0]) {
      payload.contact = {
        contactId: [...this.state.values.contacts][0],
      };
    }

    // Add subcontractor if provided. and only if workbased learning
    if (
      this.state.values.subContracted == "yes" &&
      this.state.values.subContractedProviderId &&
      (this.state.values.courseGroupType === "267040002" ||
        this.state.values.courseGroupType === "267040003")
    ) {
      payload.subContractedProvider = {
        atlasAccountId: this.state.values.subContractedProviderId,
      };
    }

    // If we have and ID then add it.
    if (this.state.values.id) {
      payload.id = this.state.values.id;
    }

    this.props.courseGroupsApiPostCourseGroup(
      payload,
      i18n.language,
      (response) => {
        // Save the current state of messages.
        let messages = this.state.messages;

        messages.add({
          type: "positive",
          message: i18n.t("local:view.courseGroups.status.success"),
        });
        this.setState({
          formErrors: [],
          redirect: route("courseGroupsManage") + this.state.query,
          messages: messages,
          submitting: false,
        });
      },
      (error) => {
        let errors = FormUtility.processServerErrors(error, i18n);

        this.setState({
          formErrors: errors.formErrors,
          messages: errors.messages,
          submitting: false,
        });
      }
    );
  }

  /**
   * Handle field onChange events and save to the state.
   * @param event
   */
  handleChange(event) {
    // Load the current state values.
    const values = { ...this.state.values };

    // Update the state with the changed value.
    this.setState(
      {
        values: FormUtility.setFormValues(event, values),
      },
      () => {
        // Reload the users permissions table.
        if (
          event.target.name == "mainProviderId" &&
          event.target.value !== ""
        ) {
          this.getUsersByAtlasAccountId(this.state.values.mainProviderId);
        }
      }
    );
  }

  /**
   * Keep track of the current input language.
   * @param event
   */
  handleSetInputLanguage(e) {
    e.preventDefault();
    this.setState({
      inputLanguage: e.target.value,
    });
  }

  /**
   * Perform a customised action if someone clicks on an error in the summary. Used to change the language to welsh.
   * @param event
   * @param field
   */
  handleErrorClick(e, field) {
    this.setState({
      inputLanguage: field.includes("_cy") ? LANGUAGE_CY : LANGUAGE_EN,
    });
  }

  /**
   * archiveCourseGroup
   * @param ids
   * @param redirect
   */
  archiveCourseGroup(id, redirect = null) {
    let messages = new Set();
    this.props.coursePortalApiArchiveCourseGroup(
      id,
      i18n.language,
      (response) => {
        if (response.data.courseIds.length === 1) {
          messages.add({
            type: "positive",
            message: i18n.t(
              "local:view.courseGroups.manage.messages.archive.singular",
              { count: response.data.courseIds.length }
            ),
          });
        } else {
          messages.add({
            type: "positive",
            message: i18n.t(
              "local:view.courseGroups.manage.messages.archive.plural",
              { count: response.data.courseIds.length }
            ),
          });
        }

        this.setState({
          redirect: redirect,
          messages: messages,
          reloadKey: Math.random(),
        });
        this.toggleModal(["archive"], false);
      },
      (error) => {
        let errors = FormUtility.processServerErrors(error, i18n);

        this.setState({
          formErrors: errors.formErrors,
          messages: errors.messages,
          showDeleteModal: false,
        });
        this.toggleModal(["archive"], false);
      }
    );
  }

  /**
   * deleteCourseGroup
   * @param ids
   * @param redirect
   */
  deleteCourseGroup(ids, redirect = null) {
    let messages = new Set();
    this.props.courseGroupsApiDeleteCourseGroups(
      ids,
      i18n.language,
      (response) => {
        messages.add({
          type: "positive",
          message: response.data.message,
        });

        // Removed for #14268
        // if (response.data.courseGroupId.length === 1) {
        //   messages.add({
        //     type: "positive",
        //     message: i18n.t(
        //       "local:view.courseGroups.manage.messages.delete.singular",
        //       { count: response.data.courseGroupId.length }
        //     ),
        //   });
        // } else {
        //   messages.add({
        //     type: "positive",
        //     message: i18n.t(
        //       "local:view.courseGroups.manage.messages.delete.plural",
        //       { count: response.data.courseGroupId.length }
        //     ),
        //   });
        // }

        this.setState({
          redirect: redirect,
          messages: messages,
          reloadKey: Math.random(),
        });
        this.toggleModal(["delete", "bulkDelete"], false);
      },
      (error) => {
        let errors = FormUtility.processServerErrors(error, i18n);

        this.setState({
          formErrors: errors.formErrors,
          messages: errors.messages,
          showDeleteModal: false,
        });
        this.toggleModal(["delete", "bulkDelete"], false);
      }
    );
  }

  /**
   * setQuery
   * @param value
   */
  setQuery(value) {
    this.setState({
      query: value,
    });
  }

  /**
   * render.
   * @returns {JSX.Element}
   */
  render() {
    return (
      <Fragment>
        <CourseGroupsView
          {...this.state}
          loadAudit={this.loadAudit}
          saveCourseGroup={this.saveCourseGroup}
          loadCourseGroup={this.loadCourseGroup}
          deleteCourseGroup={this.deleteCourseGroup}
          archiveCourseGroup={this.archiveCourseGroup}
          clearMessages={this.clearMessages}
          clearSelected={this.clearSelected}
          toggleModal={this.toggleModal}
          handleChange={this.handleChange}
          clearRedirect={this.clearRedirect}
          handleAddContact={this.handleAddContact}
          handleRemoveContacts={this.handleRemoveContacts}
          handleSelectContact={this.handleSelectContact}
          handleBulkPermissionsCheckbox={this.handleBulkPermissionsCheckbox}
          clearCourseGroup={this.clearCourseGroup}
          setReloadKey={this.setReloadKey}
          clearPermissions={this.clearPermissions}
          setQuery={this.setQuery}
        />
      </Fragment>
    );
  }
}

export default withCourseStatisticsApi(process.env)(
  withAuditApi(process.env)(
    withCoursePortalApi(process.env)(
      withCourseContactApi(process.env)(
        withCourseGroupsApi(process.env)(
          withProfileApi(process.env)(
            withAuthentication(withTranslation("local")(CourseGroupsController))
          )
        )
      )
    )
  )
);
